window.onWizzyScriptLoaded = function () {
  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-search-results");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-search-empty-results");

  // Closing their input modal on wizzy form submit
  var form = document.querySelector(".search.header-search-global-form");
  var button = document.querySelector(
    ".head-slot-global-search-link.dropdown-modal-toggle"
  );
  var modal = document.querySelector(".header-search-modal.dropdown-modal");
  var backButton = document.querySelector(".wizzy-search-back");
  if (window.innerWidth <= 786) {
    backButton.addEventListener("click", function () {
      button.setAttribute("aria-expanded", "false");
      modal.removeAttribute("open");
    });
  }
  form.addEventListener("submit", function (event) {});
  // Open Wizzy modal
  var searchIcon = document.querySelector(
    ".head-slot-item.head-slot-item-global-search"
  );
  searchIcon.addEventListener("click", function (e) {
    if (window.innerWidth <= 786) {
      var wizzyFormInput = document.querySelector(
        ".input-text.search-query.wizzy-search-input"
      );
      wizzyFormInput.click();
      setTimeout(function () {
        wizzyFormInput.click();
      }, 10);
    }
    // document.querySelector(".wizzy-search-input").click();
  });


  function reorderSuggestionsOnly(suggestions) {
    const recent = [];
    const trending = [];
    const others = [];

    let recentIndex = 0;

    suggestions.forEach(function (item) {
        if (item.group === "recentSearches") {
            if (!item.isHead) {
                item.index = recentIndex++;
            }

            recent.push(item);
        } else if (item.group === "trendingSearches") {
            trending.push(item);
        } else {
            others.push(item);
        }
    });

    return [...recent, ...trending, ...others];
  }


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {

        if (data.isForDefault === true) {
            data.suggestions = reorderSuggestionsOnly(data.suggestions);
        }

        return data;
    }
);

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0
      payload.filters = {
        configs: {
          keepOpenedInMobileAfterApply: true,
        },
      };
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        var attributues = product.attributes;
        attributues.forEach((attribute) => {
          if (attribute.id == "product_vendor") {
            product.vendor = attribute.values[0].value[0];
          }
          if (attribute.id == "product_oem_no_custom") {
            product.OEM = attribute.values[0].value[0];
          }
          if (attribute.id == "product_variant_prices") {
            if (attribute.values.length > 1) {
              product.IsConfigurableProduct = true;
            }
          }
        });
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      if (window.innerWidth <= 786) {
        backButton.click();
      }
      button.setAttribute("aria-expanded", "false");
      modal.removeAttribute("open");
      return payload;
    }
  );
const searchInput = document.querySelector('#header-global-search-input');
const searchModal = document.querySelector('.header-search-modal dropdown-modal');

let observer;

searchInput?.addEventListener('click', () => {
  setTimeout(() => {
    const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');

    if (!autocomplete || !searchModal) return;

    const updateAutocompleteVisibility = () => {
      autocomplete.style.display =
        searchModal.hasAttribute('open') ? 'none' : '';
    };

    updateAutocompleteVisibility();

    // if (observer) {
    //   observer.disconnect();
    // }

    observer = new MutationObserver(updateAutocompleteVisibility);

    observer.observe(searchModal, {
      attributes: true,
      attributeFilter: ['open']
    });
  }, 500);
});
};
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
